module.exports = __webpack_public_path__ + "img/5.af895eb3.jpg";